import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import App from '@/App'
import i18n from '@/i18n'
import store from '@/store'
import router from '@/router'
import { Button, Col, Row, Form, Input, FormItem, Card, DatePicker, Tooltip, Loading, Popover, Switch, Alert, Tabs, TabPane } from 'element-ui';
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

Vue.use(VueMeta)

Vue.use(VueAnalytics, {
   id: process.env.ANALYTICS_ID,
   router
})

Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Card)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Loading)
Vue.use(Popover)
Vue.use(Switch)
Vue.use(Alert)
Vue.use(Tabs)
Vue.use(TabPane)

/* eslint-disable no-new */
new Vue({
   el: '#app',
   i18n,
   router,
   store,
   render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js